import { createGlobalStyle } from 'styled-components';

/**
 * GlobalStyles
 * 
 * Injeta variáveis CSS no :root com base nas propriedades do tema (styled-components).
 * Isso permite o uso de var(--nome-da-variavel) em qualquer lugar do CSS/Styled Components.
 */
const GlobalStyles = createGlobalStyle`
  :root {
    /* Mapeamento de variáveis CSS vindas do objeto whitelabel */
    --primary-color: ${props => props.theme.whitelabel?.primary_color || props.theme.primary};
    --secondary-color: ${props => props.theme.whitelabel?.secondary_color || '#6c757d'};
    
    /* Novas variáveis específicas de tipografia e elementos */
    --title-color: ${props => props.theme.whitelabel?.title_color || '#1E1E1E'};
    --text-color: ${props => props.theme.whitelabel?.text_color || '#363534'};
    
    --button-primary-color: ${props => props.theme.whitelabel?.button_primary_color || props.theme.primary};
    --button-primary-text: ${props => props.theme.whitelabel?.button_primary_text || '#ffffff'};
    --button-disabled-color: ${props =>
      props.theme.whitelabel?.button_primary_color ||
      props.theme.primary ||
      '#6c757d'};
    
    --font-family-base: ${props => props.theme.whitelabel?.font_family || "'Montserrat', sans-serif"};
    
    /* Exemplo de outras variáveis que podem ser injetadas */
    --background-app: ${props => props.theme.whitelabel?.background_color || '#ffffff'};
  }

  /* Aplicação global de tipografia base */
  h1, h2, h3, h4, h5, h6 {
    color: var(--title-color);
  }

  body, p {
    font-family: var(--font-family-base);
    color: var(--text-color);
  }

  /* Links e CTAs por padrão usam a cor primária */
  a {
    color: var(--primary-color);
  }
`;

export default GlobalStyles;
